import { render, staticRenderFns } from "./ExternalLink.vue?vue&type=template&id=ae5c8ffe&"
import script from "./ExternalLink.vue?vue&type=script&lang=js&"
export * from "./ExternalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports